export const getAvatar = ({ avatar, name }: { avatar?: string; name?: string }) =>
  avatar || `https://api.dicebear.com/7.x/initials/svg?seed=${name}&backgroundColorLevel=300`;
